import initialState from '../initialState';

// Case comment is removed.
let reducers = {
  CREATE_CASE_DATA_SUCCESS: (state, payload) => {
    return [
      ...state.filter(caseData => caseData.id !== payload.id),
      Object.assign({}, payload)
    ];
  },
  LOAD_CASE_DATA_SUCCESS: (state, payload) => {
    return [
      ...state.filter(caseData => caseData.id !== payload.id),
      Object.assign({}, payload)
    ];
  },
  LOAD_ALL_CASE_DATA_SUCCESS: (state, payload) => {
    return Object.assign([], payload);
  },
  EDIT_CASE_DATA_SUCCESS: (state, payload) => {
    return [
      ...state.filter(caseData => caseData.id !== payload.id),
      Object.assign({}, payload)
    ];
  }
};


export default function caseDatas(state = initialState.caseDatas, action) {
  let reducer = reducers[action.type];
  if(action.type === "LOAD_ALL_CASE_DATA_SUCCESS"){
      return ( reducer ? reducer(state, action.caseDatas) : state);
  }
  return ( reducer ? reducer(state, action.caseData) : state);
}



/** WEBPACK FOOTER **
 ** ./src/reducers/caseData/caseDataReducer.js
 **/